<button
  type="button"
  (click)="handleToggleClick($event)"
  [ngClass]="{ toggled: isToggled }"
>
  {{ currentLang.name | uppercase }}
  <span class="typcn typcn-chevron-right" [ngClass]="{ toggled: isToggled }">
  </span>
</button>
